import React from "react";
import {getInitialState, getDefinitions} from "../services/Definitions";
import Button from "react-bootstrap/Button";
import {evaluateAct} from "../services/Evaluator";
import DetailedAuditLog from "./DetailedAuditLog";
import TransportList from "./Transports";
import RegionList from "./RegionList";
import CulturalEvent from "./CulturalEvent";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import PolitbyroAuditLog from "./PolitbyroAuditLog";
import RegionsSummaryAuditLog from "./RegionsSummaryAuditLog";
import RegionsAdminsAuditLog from "./RegionsAdminsAuditLog";
import ArmyDetailedAuditLog from "./ArmyDetailedAuditLog";
import ArmyAdminsAuditLog from "./ArmyAdminsAuditLog";
import {validateRegion, validateArmy, validateEnemy} from "../services/Validator";
import Alert from "react-bootstrap/Alert";
import ArmyCosts from "./ArmyCosts";
import ConfigTab from "./ConfigTab";
import GameStateTab from "./GameStateTab";
import ArmyAuditLog from "./ArmyAuditLog";
import ArmyList from "./ArmyList";
import InvasionList from "./InvasionList";
import OccupationList from "./OccupationList";
import CommandList from "./CommandList";
import OperationList from "./OperationList";
import RebellionList from "./RebellionList";
import Ranking from "../services/Ranking";
import OperationsPrint from "./OperationsPrint";
import { t } from "../localization";

export default class GameContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            currentState: getInitialState(),
            definitions: getDefinitions(),
            newState: null,
            history: [],
            logTab: "regionsComplete",
            formTab: "regions",
            error: null
        }
    }

    updateRegion(name, id, value) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        const region = newState.regions.find(region => region.name === name);

        if (id.includes(".")) {
            const ids = id.split(".");
            region[ids[0]][ids[1]] = value;
        } else {
            region[id] = value;
        }

        const error = validateRegion(this.state.definitions, region, newState.transports);
        if (!error) {
            this.setState({currentState: newState, error: null})
        } else {
            this.setState({error: error})
        }
    }

    toggleRegion(name) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        const region = newState.regions.find(region => region.name === name);
        region.enabled = !region.enabled;
        this.setState({currentState: newState})
    }

    addTransport(sourceRegion, targetRegion, number) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        newState.transports.push({sourceRegion: sourceRegion, targetRegion: targetRegion, number});

        const region = newState.regions.find(region => region.name === sourceRegion);
        if (region) {
            const error = validateRegion(this.state.definitions, region, newState.transports);
            if (!error) {
                this.setState({currentState: newState, error: null})
            } else {
                this.setState({error: error})
            }
        } else {
            this.setState({currentState: newState, error: null})
        }
    }

    updateConfig(newDef) {
        this.setState({definitions: newDef})
    }

    updateGameState(newGameState) {
       this.setState({currentState: newGameState})
    }

    cancelTransport(transportKey) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        if (newState.transports.length > transportKey && transportKey >= 0 ) {
            newState.transports.splice(transportKey, 1);
            this.setState({currentState: newState})
        }
    }

    selectCulturalRegion(regionKey) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        newState.eventRegion = regionKey === "" ? null : regionKey;
        this.setState({currentState: newState})
    }

    updateArmy(name, id, value) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        const army = newState.armies.find(army => army.name === name);

        if (id.includes(".")) {
          const ids = id.split(".");
          army[ids[0]][ids[1]] = value;
        } else {
          army[id] = value;
        }

        this.setState({currentState: newState, error: null})
    }

    toggleArmy(name) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        const army = newState.armies.find(army => army.name === name);
        army.enabled = !army.enabled;
        this.setState({currentState: newState})
    }

    addCommand(armyName, regionName, type, soldiers) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        newState.commands.push({army: armyName, region: regionName, type: type, soldiers: soldiers});

        const army = newState.armies.find(armyState => armyState.name === armyName);
        if (army) {
          const error = validateArmy(this.state.definitions, army, newState.commands, newState.occupations, newState.operations);
          if (!error) {
              this.setState({currentState: newState, error: null})
          } else {
              this.setState({error: error})
          }
        } else {
          this.setState({currentState: newState, error: null})
        }
    }

    cancelCommand(commandKey) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        if (newState.commands.length > commandKey && commandKey >= 0 ) {
            newState.commands.splice(commandKey, 1);
            this.setState({currentState: newState})
        }
    }

    addOperation(armyName, operationName, soldiers) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        newState.operations.push({army: armyName, operation: operationName, soldiers: soldiers});

        const army = newState.armies.find(armyState => armyState.name === armyName);
        if (army) {
          const error = validateArmy(this.state.definitions, army, newState.commands, newState.occupations, newState.operations);
          if (!error) {
              this.setState({currentState: newState, error: null})
          } else {
              this.setState({error: error})
          }
        } else {
          this.setState({currentState: newState, error: null})
        }
    }

    cancelOperation(operationKey) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        if (newState.operations.length > operationKey && operationKey >= 0 ) {
            newState.operations.splice(operationKey, 1);
            this.setState({currentState: newState})
        }
    }

    addInvasion(enemyName, regionName, type, soldiers) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        newState.invasions.push({enemy: enemyName, region: regionName,  type: type, soldiers: soldiers});
        const error = validateEnemy(this.state.definitions, enemyName, newState.invasions);
        if (!error) {
          this.setState({currentState: newState, error: null})
        } else {
          this.setState({error: error})
        }
    }

    cancelInvasion(invasionKey) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        if (newState.invasions.length > invasionKey && invasionKey >= 0 ) {
            newState.invasions.splice(invasionKey, 1);
            this.setState({currentState: newState})
        }
    }

    addRebellion(rebellionSource, rebellionTarget, rebelsCreated, rebelsMoved, rebelsRecruited) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        newState.rebellions.push({rebellionSource: rebellionSource, rebellionTarget: rebellionTarget,  rebelsCreated: rebelsCreated, rebelsMoved: rebelsMoved, rebelsRecruited: rebelsRecruited});
        this.setState({currentState: newState, error: null})
    }

    cancelRebellion(rebellionKey) {
        const newState = JSON.parse(JSON.stringify(this.state.currentState));
        if (newState.rebellions.length > rebellionKey && rebellionKey >= 0 ) {
            newState.rebellions.splice(rebellionKey, 1);
            this.setState({currentState: newState})
        }
    }

    evaluate() {
        const newState = evaluateAct(this.state.definitions, this.state.currentState);
        this.setState({newState: newState});
    }

    applyEvaluation() {
        this.state.history.push(this.state.currentState);

        const newState = JSON.parse(JSON.stringify(this.state.newState));
        this.prepareStateForNextAct(newState);


        this.setState({currentState: newState, newState: null});
    }

    prepareStateForNextAct(newState) {
        const definitions = this.state.definitions;

        newState.auditLog = [];
        newState.transports = [];
        newState.commands = [];
        newState.invasions = [];
        newState.operations = [];
        newState.rebellions = [];

        newState.regions.forEach(region => {
            definitions.coefficients.resources.types.forEach(resourceType => {
                region.constructing[resourceType] = 0;
                region.repairing[resourceType] = 0;
                region.population[resourceType] = 0;
            });
            region.population.recruiting = 0;
            region.monuments.building = 0;
            region.food = 0;
        })

        newState.armies.forEach(army => {
            army.food = 0;
            army.recruiting = 0;
        })
    }

    renderError() {
        if (this.state.error) {
            return (
                <Alert variant="danger" onClose={() => this.setState({error: null})} dismissible>
                    {this.state.error}
                </Alert>
            )
        }
    }

    renderForm() {
        return (
            <Tabs
                id="form-tabs"
                activeKey={this.state.formTab}
                onSelect={key => this.setState({ formTab: key })}
            >
                <Tab eventKey="regions" title={t("Regiony plán")}>
                    {this.renderRegions(this.state.definitions)}
                </Tab>
                <Tab eventKey="rebellions" title={t("Povstání")}>
                    {this.renderRebellions(this.state.definitions)}
                </Tab>
                <Tab eventKey="armies" title={t("Armáda plán")}>
                    {this.renderArmies(this.state.definitions)}
                </Tab>
                <Tab eventKey="armyCosts" title={t("Armáda náklady")}>
                    <ArmyCosts defs={this.state.definitions}/>
                </Tab>
                <Tab eventKey="foreignArmies" title={t("Cizí armády")}>
                    {this.renderForeignArmies(this.state.definitions)}
                </Tab>
                <Tab eventKey="config" title={t("Konfigurace")}>
                    <ConfigTab
                        defs={this.state.definitions}
                        updateHandler={this.updateConfig.bind(this)}
                        originalDefs={getDefinitions()}/>
                </Tab>
                <Tab eventKey="gameState" title={t("Stav hry")}>
                    <GameStateTab
                        gameState={this.state.currentState}
                        updateHandler={this.updateGameState.bind(this)}/>
                </Tab>
                <Tab eventKey="operationsPrint" title={t("Operace")}>
                    <OperationsPrint defs={this.state.definitions}/>
                </Tab>
            </Tabs>

        )
    }

    renderRegions(definitions) {
        return (
            <div className="mt-4">
                <h3 id="main-title">{t("Plán hospodářství pro")} {this.state.history.length + 1}. {t("dějství")}</h3>
                {this.renderError()}

                <RegionList definitions={definitions}
                            currentState={this.state.currentState}
                            updateHandler={this.updateRegion.bind(this)}
                            toggleRegion={this.toggleRegion.bind(this)}
                />

                <TransportList defs={definitions}
                               currentState={this.state.currentState}
                               transports={this.state.currentState.transports}
                               addTransport={this.addTransport.bind(this)}
                               cancelTransport={this.cancelTransport.bind(this)}/>

                <CulturalEvent defs={definitions}
                               currentState={this.state.currentState}
                               transports={this.state.currentState.transports}
                               selectCulturalRegion={this.selectCulturalRegion.bind(this)}/>


                <div className="mt-3 no-print">
                    <Button variant="primary" onClick={this.evaluate.bind(this)} className="mr-2">
                        {t("Vyhodnotit dějství")}
                    </Button>
                </div>
            </div>
        )
    }

    renderArmies(definitions) {
        return (
            <div className="mt-4">
                <h3 id="main-title">{t("Plán armád pro")} {this.state.history.length + 1}. {t("dějství")}</h3>
                {this.renderError()}

                <ArmyList definitions={definitions}
                            currentState={this.state.currentState}
                            updateHandler={this.updateArmy.bind(this)}
                            toggleArmy={this.toggleArmy.bind(this)}
                />

                <CommandList defs={definitions}
                              currentState={this.state.currentState}
                              commands={this.state.currentState.commands}
                              addCommand={this.addCommand.bind(this)}
                              cancelCommand={this.cancelCommand.bind(this)}
                />

                <OperationList defs={definitions}
                            currentState={this.state.currentState}
                            addOperation={this.addOperation.bind(this)}
                            cancelOperation={this.cancelOperation.bind(this)}
                />

                <div className="mt-3 no-print">
                    <Button variant="primary" onClick={this.evaluate.bind(this)} className="mr-2">
                        {t("Vyhodnotit dějství")}
                    </Button>
                </div>
            </div>
        )
    }

    renderRebellions(definitions) {
        return (
            <div className="mt-4">
                <h3 id="main-title">{t("Plán povstání pro")} {this.state.history.length + 1}. {t("dějství")}</h3>
                {this.renderError()}

                <RebellionList defs={definitions}
                              currentState={this.state.currentState}
                              addRebellion={this.addRebellion.bind(this)}
                              cancelRebellion={this.cancelRebellion.bind(this)}
                />

                <div className="mt-3 no-print">
                    <Button variant="primary" onClick={this.evaluate.bind(this)} className="mr-2">
                        {t("Vyhodnotit dějství")}
                    </Button>
                </div>
            </div>
        )
    }

    renderForeignArmies(definitions) {
        return (
            <div className="mt-4">
                <h3 id="main-title">{t("Plán cizích armád pro")} {this.state.history.length + 1}. {t("dějství")}</h3>
                {this.renderError()}

                <OccupationList defs={definitions}
                            currentState={this.state.currentState}
                />

                <InvasionList defs={definitions}
                            currentState={this.state.currentState}
                            addInvasion={this.addInvasion.bind(this)}
                            cancelInvasion={this.cancelInvasion.bind(this)}
                />

                <div className="mt-3 no-print">
                    <Button variant="primary" onClick={this.evaluate.bind(this)} className="mr-2">
                        {t("Vyhodnotit dějství")}
                    </Button>
                </div>
            </div>
        )
    }

    renderEvaluation() {
        const definitions = this.state.definitions;
        const disabledRegions = this.state.newState.regions.filter(region => !region.enabled).map(region => region.name);
        const disabledArmies = this.state.newState.armies.filter(army => !army.enabled).map(army => army.name);
        const ranking = new Ranking(definitions, disabledRegions, disabledArmies, this.state.newState.auditLog);
        return (
            <div className="reports">
                <h3 id="main-title">{t("Výsledky hospodářství za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                <Tabs
                    id="log-tabs"
                    activeKey={this.state.logTab}
                    onSelect={key => this.setState({ logTab: key })}
                >
                    <Tab eventKey="regionsComplete" title={t("Regiony kompletní")}>
                        <h3 className="tab-print-title">{t("Jednotlivé regiony za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <DetailedAuditLog definitions={definitions}
                                          auditLog={this.state.newState.auditLog}
                                          disabledRegions={disabledRegions}
                                          ranking={ranking}/>
                    </Tab>
                    <Tab eventKey="regionsSummary" title={t("Regiony shrnutí")}>
                        <h3 className="tab-print-title">{t("Shrnutí regionů za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <RegionsSummaryAuditLog definitions={definitions}
                                          auditLog={this.state.newState.auditLog}
                                          disabledRegions={disabledRegions}
                                          ranking={ranking}/>
                    </Tab>
                    <Tab eventKey="regionsAdmins" title={t("Regiony orgové")}>
                        <h3 className="tab-print-title">{t("Regiony pro sekretáře za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <RegionsAdminsAuditLog definitions={definitions}
                                          auditLog={this.state.newState.auditLog}
                                          disabledRegions={disabledRegions}
                                          ranking={ranking}/>
                    </Tab>
                    <Tab eventKey="politbyro" title={t("Politbyro")}>
                        <h3 className="tab-print-title">{t("Zpráva pro Politbyro za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <PolitbyroAuditLog definitions={definitions}
                                           auditLog={this.state.newState.auditLog}
                                           disabledRegions={disabledRegions}
                                           disabledArmies={disabledArmies}
                                           ranking={ranking}/>
                    </Tab>
                    <Tab eventKey="armyDetail" title={t("Armáda kompletní")}>
                        <h3 className="tab-print-title">{t("Jednotlivé armády za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <ArmyDetailedAuditLog definitions={definitions}
                                      auditLog={this.state.newState.auditLog}
                                      disabledArmies={disabledArmies}
                                      ranking={ranking}/>
                    </Tab>
                    <Tab eventKey="armySummary" title={t("Armáda shrnutí")}>
                        <h3 className="tab-print-title">{t("Shrnutí armády za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <ArmyAuditLog definitions={definitions}
                                      auditLog={this.state.newState.auditLog}
                                      disabledArmies={disabledArmies}
                                      ranking={ranking}/>
                    </Tab>
                    <Tab eventKey="armyAdmins" title={t("Armáda orgové")}>
                        <h3 className="tab-print-title">{t("Armády pro sekretáře za")} {this.state.history.length + 1}. {t("dějství")}</h3>
                        <ArmyAdminsAuditLog definitions={definitions}
                                      auditLog={this.state.newState.auditLog}
                                      disabledArmies={disabledArmies}
                                      ranking={ranking}/>
                    </Tab>
                </Tabs>

                <div className="mt-3 no-print">
                    <Button variant="primary" onClick={this.applyEvaluation.bind(this)} className="mr-2">
                        {t("Potvrdit vyhodnocení")}
                    </Button>
                    <Button variant="secondary" onClick={() => this.setState({"newState": null})} className="mr-2">
                        {t("Zpět na zadávání")}
                    </Button>
                </div>
            </div>
        )
    }

    render() {
        return (
            <div className={`container mt-2 ${this.state.error ? "invalid" : ""}`}>
                {this.state.newState ? this.renderEvaluation() : this.renderForm()}
            </div>
        )
    }
}
